import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invalid-order-alert__container" }

import { i18n } from '@/i18n';
import { IRecommendOrderErrorType } from '../pages/interfaces/recommendOrderError';
import { RecommendOrderViewModel } from '../pages/recommendOrderViewModel';


export default /*@__PURE__*/_defineComponent({
  __name: 'InvalidOrderAlert',
  props: {
    errorType: {}
  },
  setup(__props: any) {

const t = i18n.t;



const vm = new RecommendOrderViewModel();

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_i18n_t, {
      class: "invalid-order-alert__content",
      keypath: _unref(vm).getI18nKeyPathOfErrorMessage(_ctx.errorType),
      tag: "div"
    }, {
      newLine: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("br", null, null, -1)
      ])),
      _: 1
    }, 8, ["keypath"])
  ]))
}
}

})